import styled from 'styled-components';

export const EditorContainer = styled.article`
  flex: 1;
  overflow: auto;
`;
export const EditorBody = styled.div`
  height: 100%;
`;
